import { Injectable } from '@angular/core';
import { DataStorageService } from '../../data-storage.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SecurityService } from '../../security.service';
import { ConfigService } from '../../config.service';


@Injectable()
export class ApiTextService {

  constructor(private dataStorageService: DataStorageService,
    private http: HttpClient,
    private config: ConfigService,
    private security: SecurityService) { }

  getAllUITexts(): Promise<KeyValuePair[]> {
    const url = this.config.host
      + '/api/config/ui-text';
    return new Promise<KeyValuePair[]>((resolve, reject) => {
      this.http.get<KeyValuePair[]>(url)
        .subscribe(response => resolve(response),
          (error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.security.refreshToken().then(() => this.getAllUITexts().then(r => resolve(r)));
            } else {
              alert(error.message);
              reject();
            }
          });
    });
  }

  putUIText(key: string, value: string): Promise<any> {
    const url = this.config.host
      + '/api/config/ui-text/'
      + key;
    const body = {
      value: value
    };

    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body).subscribe(() => { }, (error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.security.refreshToken().then(() => this.putUIText(key, value).then(() => resolve()));
          } else {
            if (error.status >= 400 && error.status < 500) {
              alert('ERROR: Please contact with your administrator');
            } else {
              alert('Please check your internet connection');
            }
            reject();
          }
        });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/apiServices/text/text.service.ts